// extracted by mini-css-extract-plugin
export default {"container":"styles_container__qC29l","text":"styles_text__BLc8n","gradient":"styles_gradient__DEgU0","disabled":"styles_disabled__SuYuS"};